import {
  GetAllNationalityLookup,
  GetAllReligionLookup,
  GetAllDesignationLookup,
  GetAllJobGradeLookup,
  GetAllUserTypeLookup,
  GetAllWorkLocationLookup,
  updateWorkLocationLookup,
  AddWorkLocationLookup,
  DeleteWorkLocationLookup,
  updateReligionLookup,
  AddReligionLookup,
  DeleteReligionLookup,
  updateNationalityLookup,
  AddNationalityLookup,
  DeleteNationalityLookup,
  AddDesignationLookup,
  UpdateDesignationLookup,
  DeleteDesignationLookup,
  AddDesignationCategoryLookup,
  UpdateDesignationCategoryLookup,
  DeleteDesignationCategoryLookup,
  DeleteUserTypeLookup,
  AddUserTypeLookup,
  UpdateUserTypeLookup,
  DeleteJobGradeLookup,
  AddJobGradeLookup,
  UpdateJobGradeLookup,
  GetAllEmployeeExceptionLookup,
  AddEmployeeExceptionLookup,
  UpdateEmployeeExceptionLookup,
  DeleteEmployeeExceptionLookup,
  GetAllReaderLookup,
  AddReaderLookup,
  UpdateReaderLookup,
  DeleteReaderLookup,
  GetAllCompanyLookup,
  AddCompanyLookup,
  UpdateCompanyLookup,
  DeleteCompanyLookup,
  GetAllCompanyTypeLookup,
  GetAllCompanySizeLookup,
  GetAllNoLocationsLookup,
  GetAllEntityLookup,
  GetAllEntityPaginatedLookup,
  GetAllEntityByParentId,
  AddEntityLookup,
  UpdateEntityLookup,
  DeleteEntityLookup,
  GetAllEntityLevelLookup,
  AddEntityLevelLookup,
  UpdateEntityLevelLookup,
  DeleteEntityLevelLookup,
  GetAllEmployeeLookup,
  GetEmployeesByEntityId,
  GetEmployeesByNumber,
  AddEmployeeLookup,
  UpdateEmployeeLookup,
  DeleteEmployeeLookup,
  DeleteEmployeeTypeLookup,
  GetAllEmployeeTypeLookup,
  AddEmployeeTypeLookup,
  UpdateEmployeeTypeLookup,
  GetAllEmployeeStatusLookup,
  AddEmployeeStatusLookup,
  UpdateEmployeeStatusLookup,
  DeleteEmployeeStatusLookup,
  GetAllActiveEmployeeLookup,
  GetAllFormControlLookup,
  UpdateFormLookup,
  AddFormLookup,
  GetFormLookup,
  AddLeaveDefinitionLookup,
  GetLeaveDefinitionLookup,
  DeleteLeaveDefinitionLookup,
  DeleteEmployeeGroupLookup,
  GetEmployeeGroupLookup,
  AddEmployeeGroupLookup,
  UpdateEmployeeGroupLookup,
  GetWorkFlowStagesLookup,
  GetWorkFlowAssignTypesLookup,
  GetWorkFlowLookup,
  AddWorkFlowLookup,
  UpdateWorkFlowLookup,
  DeleteWorkFlowLookup,
  UpdateLeaveDefinitionLookup,
  GetAllTargetEmployeesLookup,
  AddPolicyLookup,
  UpdatePolicyLookup,
  GetPolicyLookup,
  DeletePolicyLookup,
  GetFormByWorkFlowlookup,
  GetFullWorkFlowDetailsLookup,
  ChangePolicyPriorityLookup,
  GetFilterPolicyLookup,
  GetNotificationTypesLookup,
  SaveNotificationLookup,
  AddNotificationLookup,
  UpdateNotificationLookup,
  DeleteNotificationLookup,
  GetNotificationLookup,
  GetByIDNotificationLookup,
  DeleteFormlookup,
  GetAllManagersLookup,
  GetSubordinatesLookup,
  AddManagerDelegationLookup,
  UpdateManagerDelegationLookup,
  DeleteManagerDelegationLookup,
  GetAllManagerDelegationLookup,
  GetAllLeaveTypeLookup,
  AddLeaveTypeLookup,
  UpdateLeaveTypeLookup,
  DeleteLeaveTypeLookup,
  GetAllEmployeelookUps,
  GetAllEmployeeLeavesLookup,
  AddEmployeelookUps,
  UpdateEmployeelookUps,
  DeleteEmployeelookUps,
  GetEmployeeByID,
  GetEmployeePaginationLookup,
  GetAllDesignationCategoryLookup,
  DeleteRemoteWorkDefinitionLookup,
  UpdateRemoteWorkDefinitionLookup,
  AddRemoteWorkDefinitionLookup,
  GetRemoteWorkDefinitionLookup,
  GetAllEmployeeEntityPrivilagesLookup,
  AddEmployeeEntityPrivilagesLookup,
  DeleteEmployeeEntityPrivilagesLookup,
  GetAllEmployeeContractLookup,
  AddEmployeeContractLookup,
  DeleteEmployeeContractLookup,
  GetAllBreakDefinition,
  AddBreakDefinition,
  UpdateBreakDefinition,
  GetAllMetaData
} from '../api-request/lookup-requests';
import { Get, Post, Put, Delete } from '../api-middleware';
import { getCompanyID } from '../../helpers/Utils';

const API_BASE_URL = 'https://bos-apim-uaenorth.azure-api.net/OrganizationService/api';



const TransformUserRoleMenuActions = (apiResponse, isArabicUI = false) => {
  if (!apiResponse?.data) {
    console.warn('Invalid API response format for UserRole menu actions');
    return [];
  }

  // New API structure: separate moduleList and menuActionMappingList arrays
  const moduleList = apiResponse.data.moduleList || [];
  const menuActionMappings = apiResponse.data.menuActionMappingList || [];

  console.log('📋 Module list from API:', moduleList);
  console.log('📋 Menu action mappings from API:', menuActionMappings.length, 'items');
  console.log('📋 Language mode:', isArabicUI ? 'Arabic' : 'English');

  // Pre-populate module map with available modules for faster processing
  const moduleMap = new Map();
  moduleList.forEach((moduleName) => {
    if (moduleName && typeof moduleName === 'string') {
      // Use crypto.randomUUID for absolute uniqueness (fallback to timestamp if not available)
      const uniqueId = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `module-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      moduleMap.set(moduleName, {
        id: uniqueId,
        nameEn: null, // Will be populated from menuActionMappings
        nameAr: null, // Will be populated from menuActionMappings
        displayName: moduleName, // Initial display name from API (could be En or Ar)
        permissions: new Map()
      });
    }
  });

  console.log('📋 Pre-populated modules from API:', Array.from(moduleMap.keys()));

  // Process menu action mappings - only for modules that exist in moduleList
  menuActionMappings.forEach(item => {
    const moduleNameEn = item.menuDefinition?.moduleNameEn;
    const moduleNameAr = item.menuDefinition?.moduleNameAr;
    const menuCode = item.menuDefinition?.menuCode;
    const menuName = isArabicUI
      ? (item.menuDefinition?.menuNameAr || item.menuDefinition?.menuNameEn)
      : (item.menuDefinition?.menuNameEn || item.menuDefinition?.menuNameAr);
    const actionName = isArabicUI
      ? (item.actionDefinition?.actionNameAr || item.actionDefinition?.actionNameEn)
      : (item.actionDefinition?.actionNameEn || item.actionDefinition?.actionNameAr);
    const actionId = item.actionDefinition?.id;
    const order = item.actionDefinition?.order || 0;

    // Try to match by Arabic name first (since moduleList might contain Arabic), then English
    let matchedModule = null;
    if (moduleNameAr && moduleMap.has(moduleNameAr)) {
      matchedModule = moduleMap.get(moduleNameAr);
    } else if (moduleNameEn && moduleMap.has(moduleNameEn)) {
      matchedModule = moduleMap.get(moduleNameEn);
    }

    if (!matchedModule) {
      console.warn('Module not in available list:', { moduleNameEn, moduleNameAr, availableModules: Array.from(moduleMap.keys()) });
      return;
    }

    // Update module with both English and Arabic names
    if (moduleNameEn && !matchedModule.nameEn) {
      matchedModule.nameEn = moduleNameEn;
    }
    if (moduleNameAr && !matchedModule.nameAr) {
      matchedModule.nameAr = moduleNameAr;
    }
    // Update display name based on language
    matchedModule.displayName = isArabicUI 
      ? (matchedModule.nameAr || matchedModule.nameEn || matchedModule.displayName)
      : (matchedModule.nameEn || matchedModule.nameAr || matchedModule.displayName);

    if (!menuCode || !actionName) {
      console.warn('Missing required fields in menu action item:', item);
      return;
    }

    // Initialize permission section if not exists
    if (!matchedModule.permissions.has(menuCode)) {
      const sectionUniqueId = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `section-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      matchedModule.permissions.set(menuCode, {
        id: sectionUniqueId,
        name: menuName || menuCode, // Use localized menu name, fallback to menuCode
        menuDefinitionID: item.menuDefinition?.id, // Store the actual menuDefinitionID from API
        data: []
      });
    }

    const section = matchedModule.permissions.get(menuCode);

    // Store menuDefinitionID if not already stored
    if (!section.menuDefinitionID) {
      section.menuDefinitionID = item.menuDefinition?.id;
    }

    // Add action if not already exists
    const existingAction = section.data.find(action => action.actionId === actionId);
    if (!existingAction) {
      const permissionUniqueId = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `permission-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      section.data.push({
        id: permissionUniqueId,
        name: actionName,
        nameEn: item.actionDefinition?.actionNameEn,
        nameAr: item.actionDefinition?.actionNameAr,
        actionId: actionId, // Store the actual actionId from API
        selected: false,
        order: order
      });
    }
  });

  // Convert Map to Array and sort actions by order
  const result = Array.from(moduleMap.values()).map(module => ({
    id: module.id,
    name: module.displayName || module.nameEn, // Use displayName (localized) or fallback to English
    permissions: Array.from(module.permissions.values()).map(section => {
      const { permissions, ...sectionData } = section; // Remove the Map object
      return {
        ...sectionData,
        data: section.data.sort((a, b) => (a.order || 0) - (b.order || 0))
      };
    })
  }));

  console.log('📋 Transformed UserRole menu actions:', result);
  return result;
};

const GetNationality = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllNationalityLookup}/${getCompanyID()}`,
  });
  return response;
};

const SaveNationality = async (nationality, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddNationalityLookup}`,
      data: nationality,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${updateNationalityLookup}/${id}`,
      data: nationality,
    });
    return response;
  }
};
const DeleteNationality = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteNationalityLookup}/${id}`,
  });
  return response;
};

const SaveWorkLocations = async (workLocation, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddWorkLocationLookup}`,
      data: workLocation,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${updateWorkLocationLookup}/${id}`,
      data: workLocation,
    });
    return response;
  }
};
const DeleteWorkLocation = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteWorkLocationLookup}/${id}`,
  });
  return response;
};
const GetReligion = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllReligionLookup}/${getCompanyID()}`,
  });
  return response;
};

const SaveReligion = async (religion, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddReligionLookup}`,
      data: religion,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${updateReligionLookup}/${id}`,
      data: religion,
    });
    return response;
  }
};
const DeleteReligion = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteReligionLookup}/${id}`,
  });
  return response;
};

const GetDesignation = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllDesignationLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveDesignation = async (designation, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddDesignationLookup}`,
      data: designation,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateDesignationLookup}/${id}`,
      data: designation,
    });
    return response;
  }
};
const DeleteDesignation = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteDesignationLookup}/${id}`,
  });
  return response;
};

const GetDesignationCategory = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllDesignationCategoryLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveDesignationCategory = async (designation, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddDesignationCategoryLookup}`,
      data: designation,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateDesignationCategoryLookup}/${id}`,
      data: designation,
    });
    return response;
  }
};
const DeleteDesignationCategory = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteDesignationCategoryLookup}/${id}`,
  });
  return response;
};

const GetEmployeeType = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeTypeLookup}/${getCompanyID()}`,
  });
  return response;
};
const DeleteEmployeeType = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeTypeLookup}/${id}`,
  });
  return response;
};

const SaveEmployeeType = async (employeeType, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeTypeLookup}`,
      data: employeeType,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEmployeeTypeLookup}/${id}`,
      data: employeeType,
    });
    return response;
  }
};

const GetJobGrade = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllJobGradeLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveJobGrade = async (jobGrade, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddJobGradeLookup}`,
      data: jobGrade,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateJobGradeLookup}/${id}`,
      data: jobGrade,
    });
    return response;
  }
};
const DeleteJobGrade = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteJobGradeLookup}/${id}`,
  });
  return response;
};

const GetUserType = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllUserTypeLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveUserType = async (userType, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddUserTypeLookup}`,
      data: userType,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateUserTypeLookup}/${id}`,
      data: userType,
    });
    return response;
  }
};
const DeleteUserType = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteUserTypeLookup}/${id}`,
  });
  return response;
};
const GetWorkLocation = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllWorkLocationLookup}/${getCompanyID()}`,
  });
  return response;
};

const GetEmployeeException = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeExceptionLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveEmployeeException = async (employeeException, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeExceptionLookup}`,
      data: employeeException,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEmployeeExceptionLookup}/${id}`,
      data: employeeException,
    });
    return response;
  }
};
const DeleteEmployeeException = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeExceptionLookup}/${id}`,
  });
  return response;
};

const GetReader = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllReaderLookup}`,
  });
  return response;
};
const SaveReader = async (reader, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddReaderLookup}`,
      data: reader,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateReaderLookup}/${id}`,
      data: reader,
    });
    return response;
  }
};
const DeleteReader = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteReaderLookup}/${id}`,
  });
  return response;
};

const GetCompany = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllCompanyLookup}`,
  });
  return response;
};

const SaveCompany = async (company, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddCompanyLookup}`,
      data: company,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateCompanyLookup}/${id}`,
      data: company,
    });
    return response;
  }
};
const DeleteCompany = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteCompanyLookup}/${id}`,
  });
  return response;
};
const GetCompanySize = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllCompanySizeLookup}`,
  });
  return response;
};
const GetCompanyType = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllCompanyTypeLookup}`,
  });
  return response;
};

const GetNoLocations = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllNoLocationsLookup}`,
  });
  return response;
};

const GetEntity = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEntityLookup}/${getCompanyID()}`,
  });
  return response;
};

const GetEntityPaginated = async (params) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEntityPaginatedLookup}/${getCompanyID()}/${params.pageNumber}/${params.pageSize}/${params.keyword}`,
  });
  return response;
};

const GetEntityByParentId = async (Id) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEntityByParentId}/${getCompanyID()}/${Id}`,
  });
  return response;
};

const SaveEntity = async (entity, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEntityLookup}`,
      data: entity,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEntityLookup}/${id}`,
      data: entity,
    });
    return response;
  }
};
const DeleteEntity = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEntityLookup}/${id}`,
  });
  return response;
};

const GetEntityLevel = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEntityLevelLookup}/${getCompanyID()}`,
  });
  return response;
};

const SaveEntityLevel = async (entity, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEntityLevelLookup}`,
      data: entity,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEntityLevelLookup}/${id}`,
      data: entity,
    });
    return response;
  }
};
const DeleteEntityLevel = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEntityLevelLookup}/${id}`,
  });
  return response;
};

const GetEmployee = async (params = 1) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeLookup}/${getCompanyID()}/${getEmployeeID()}/${params}`,
  });
  return response;
};

export const GetEmployeePagination = async (params, thunkAPI) => {
  try {
    const response = await Post({
      url: `${API_BASE_URL}${GetEmployeePaginationLookup}/${getCompanyID()}/${getEmployeeID()}`,
      data: params,
    });
    return response?.data?.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message);
  }
};

const GetEmployeeByIDApi = async (Id) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetEmployeeByID}/${Id}`,
  });
  return response;
};

const GetEmployeeByEntityId = async (Id) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetEmployeesByEntityId}/${Id}`,
  });
  return response;
};

const getEmployeeByNumber = async (Number) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetEmployeesByNumber}/${Number}`,
  });
  return response;
};

const SaveEmployee = async (entity, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeLookup}`,
      data: entity,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEmployeeLookup}/${id}`,
      data: entity,
    });
    return response;
  }
};
const DeleteEmployee = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeLookup}/${id}`,
  });
  return response;
};

const GetEmployeeStatus = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeStatusLookup}/${getCompanyID()}`,
  });
  return response;
};

const SaveEmployeeStatus = async (employeeStatus, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeStatusLookup}`,
      data: employeeStatus,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEmployeeStatusLookup}/${id}`,
      data: employeeStatus,
    });
    return response;
  }
};
const DeleteEmployeeStatus = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeStatusLookup}/${id}`,
  });
  return response;
};

const GetAllActiveEmployee = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeLookup}/${getCompanyID()}`,
  });
  return response;
};
const GetFormControl = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllFormControlLookup}`,
  });
  return response;
};
const SaveForm = async (form, id) => {
  if (!id || id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddFormLookup}`,
      data: form,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateFormLookup}/${id}`,
      data: form,
    });
    return response;
  }
};

const GetForms = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetFormLookup}/${getCompanyID()}`,
  });
  return response;
};

const GetLeaveDefinition = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetLeaveDefinitionLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveLeaveDefinition = async (LeaveDefinition, id) => {
  if (!id || id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddLeaveDefinitionLookup}`,
      data: LeaveDefinition,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateLeaveDefinitionLookup}/${id}`,
      data: LeaveDefinition,
    });
    return response;
  }
};
const DeleteLeaveDefinition = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteLeaveDefinitionLookup}/${id}`,
  });
  return response;
};

const GetEmployeeGroup = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetEmployeeGroupLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveEmployeeGroup = async (employeeGroup, id) => {
  if (!id || id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeGroupLookup}`,
      data: employeeGroup,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateEmployeeGroupLookup}/${id}`,
      data: employeeGroup,
    });
    return response;
  }
};
const DeleteEmployeeGroup = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeGroupLookup}/${id}`,
  });
  return response;
};

const GetWorkFlowStages = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetWorkFlowStagesLookup}`,
  });
  return response;
};
const GetWorkFlowAssignTypes = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetWorkFlowAssignTypesLookup}`,
  });
  return response;
};
const SaveWorkFlow = async (workFlow, id) => {
  if (!id || id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddWorkFlowLookup}`,
      data: workFlow,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateWorkFlowLookup}/${id}`,
      data: workFlow,
    });
    return response;
  }
};
const GetWorkFlow = async ({ workFLowFor }) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetWorkFlowLookup}/${getCompanyID()}/${workFLowFor}`,
  });
  return response;
};

const DeleteWorkFLow = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteWorkFlowLookup}/${id}`,
  });
  return response;
};
const GetAllTargetEmployees = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllTargetEmployeesLookup}/${getCompanyID()}`,
  });
  return response;
};
const GetAllPolicy = async (request) => {
  const response = await Post({
    url: `${API_BASE_URL}${GetFilterPolicyLookup}`,
    data: request,
  });
  return response;
};
const DeletePolicy = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeletePolicyLookup}/${id}`,
  });
  return response;
};

const ChangePolicyPriority = async (request) => {
  const response = await Post({
    url: `${API_BASE_URL}${ChangePolicyPriorityLookup}`,
    data: request,
  });
  return response;
};

const GetAllEmployeeLeaves = async (request) => {
  const response = await Post({
    url: `${API_BASE_URL}${GetAllEmployeeLeavesLookup}`,
    data: request,
  });
  return response;
};

const SavePolicy = async (policy, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddPolicyLookup}`,
      data: policy,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdatePolicyLookup}/${id}`,
      data: policy,
    });
    return response;
  }
};

const GetFormByWorkFlow = async (data) => {
  const response = await Post({
    url: `${API_BASE_URL}${GetFormByWorkFlowlookup}`,
    data,
  });
  return response;
};

const GetFullWorkFlowDetails = async (workFlowID) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetFullWorkFlowDetailsLookup}/${workFlowID}`,
  });
  return response;
};

const GetNotificationTypes = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetNotificationTypesLookup}/${getCompanyID()}`,
  });
  return response;
};

const SaveNotification = async (request, id) => {
  if (id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddNotificationLookup}`,
      data: request,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateNotificationLookup}/${id}`,
      data: request,
    });
    return response;
  }
};
const DeleteNotification = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteNotificationLookup}/${id}`,
  });
  return response;
};
const GetNotification = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetNotificationLookup}/${getCompanyID()}/${NotificationTypes.Default}`,
  });
  return response;
};
const GetNotificationByID = async (id) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetByIDNotificationLookup}/${id}`,
  });
  return response;
};
const GetNotificationByKind = async (notificationKind) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetNotificationLookup}/${getCompanyID()}/${notificationKind}`,
  });
  return response;
};
const DeleteForm = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteFormlookup}/${id}`,
  });
  return response;
};

const GetAllManagers = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllManagersLookup}/${getCompanyID()}`,
  });
  return response;
};
const GetAllSubordinates = async (managerID) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetSubordinatesLookup}/${managerID}`,
  });
  return response;
};

const GetLeaveType = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllLeaveTypeLookup}/${getCompanyID()}`,
  });
  return response;
};

const SaveLeaveType = async (leaveType, id) => {
  if (id === 0) {
    const response = await Post({
      url: `${API_BASE_URL}${AddLeaveTypeLookup}`,
      data: leaveType,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateLeaveTypeLookup}/${id}`,
      data: leaveType,
    });
    return response;
  }
};
const DeleteLeaveType = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteLeaveTypeLookup}/${id}`,
  });
  return response;
};

const GetEmployeeCategory = async () => {
  const response = await Post({
    url: `${API_BASE_URL}${GetAllEmployeelookUps}`,
    data: {
      companyID: getCompanyID(),
      type: '1',
    },
  });
  return response;
};

const SaveEmployeeLookups = async (params, id) => {
  let response = null;
  if (id === 0) {
    response = await Post({
      url: `${API_BASE_URL}${AddEmployeelookUps}`,
      data: params,
    });
  } else {
    response = await Put({
      url: `${API_BASE_URL}${UpdateEmployeelookUps}/${params.id}`,
      data: params,
    });
  }
  return response;
};
const DeleteEmployeeLookups = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeelookUps}/${id}`,
  });
  return response;
};



const GetUserRoleById = async (roleId, companyId = null) => {
  const actualCompanyId = companyId || getCompanyID();
  const response = await Get({
    url: `${API_BASE_URL}/role/get?companyID=${actualCompanyId}&roleID=${roleId}`,
  });
  return response;
};

const GetEmployeeLookupById = async (id) => {
  const response = await Get({
    url: `${API_BASE_URL}/employee-lookups/get/${id}`,
  });
  return response;
};

const GetEmployeeLookups = async (type) => {
  const response = await Post({
    url: `${API_BASE_URL}${GetAllEmployeelookUps}`,
    data: {
      companyID: getCompanyID(),
      type: type.toString(),
    },
  });
  return response;
};

const GetRemoteWorkDefinition = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetRemoteWorkDefinitionLookup}/${getCompanyID()}`,
  });
  return response;
};
const SaveRemoteWorkDefinition = async (RemoteWorkDefinition, id) => {
  if (!id || id === '') {
    const response = await Post({
      url: `${API_BASE_URL}${AddRemoteWorkDefinitionLookup}`,
      data: RemoteWorkDefinition,
    });
    return response;
  } else {
    const response = await Put({
      url: `${API_BASE_URL}${UpdateRemoteWorkDefinitionLookup}/${id}`,
      data: RemoteWorkDefinition,
    });
    return response;
  }
};
const DeleteRemoteWorkDefinition = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteRemoteWorkDefinitionLookup}/${id}`,
  });
  return response;
};

const GetEmployeeEntityPrivilege = async (employeeID) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeEntityPrivilagesLookup + '/' + employeeID}`,
  });
  return response;
};
const SaveEmployeeEntityPrivilege = async (EmployeeEntityPrivilege, id) => {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeEntityPrivilagesLookup}`,
      data: EmployeeEntityPrivilege,
    });
    return response;
};
const DeleteEmployeeEntityPrivilege = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeEntityPrivilagesLookup + '/' + id}`,
  });
  return response;
};

const GetEmployeeContract = async (employeeID) => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllEmployeeContractLookup + '/' + employeeID}`,
  });
  return response;
};
const SaveEmployeeContract = async (EmployeeContract, id) => {
    const response = await Post({
      url: `${API_BASE_URL}${AddEmployeeContractLookup}`,
      data: EmployeeContract,
    });
    return response;
};
const DeleteEmployeeContract = async (id) => {
  const response = await Delete({
    url: `${API_BASE_URL}${DeleteEmployeeContractLookup}/${id}`,
  });
  return response;
};

// Helper function to convert lookupCode to proper case
const formatLookupCode = (lookupCode) => {
  if (!lookupCode) return '';
  // Convert to lowercase and capitalize first letter
  return lookupCode.charAt(0).toUpperCase() + lookupCode.slice(1).toLowerCase();
};

// Meta Data Functions
const GetMetaData = async () => {
  const response = await Get({
    url: `${API_BASE_URL}${GetAllMetaData}?companyId=${getCompanyID()}`,
  });
  return response;
};

// Get lookup metadata (columns configuration)
const GetLookupMetadata = async (companyId, tableCode) => {
  const response = await Get({
    url: `${API_BASE_URL}/meta-data/get-all?companyId=${companyId}&tableCode=${tableCode}`,
  });
  return response;
};

// Get UserRole menu actions for permissions
const GetUserRoleMenuActions = async (companyId = null, menuCode = null) => {
  let url = `${API_BASE_URL}/role/get-menu-actions?companyID=${companyId || getCompanyID()}`;

  // Add menuCode filter if provided (for future filtering capability)
  if (menuCode) {
    url += `&menuCode=${encodeURIComponent(menuCode)}`;
  }

  const response = await Get({
    url: url,
  });

  return response;
};

// Get all lookup data by lookup code with filters, sorting, and pagination (POST)
const GetLookupData = async (lookupCode, payload = null) => {
  const defaultPayload = {
    conditions: [],
    sortColumn: '',
    sortDirection: '',
    skip: 0,
    take: 100,
    companyID: getCompanyID() || ''
  };

  const response = await Post({
    url: `${API_BASE_URL}/employee-lookups/get-all?lookupCode=${lookupCode}`,
    data: payload || defaultPayload,
  });
  return response;
};

// Get single lookup item by ID
const GetLookupItemById = async (lookupCode, id) => {
  const formattedCode = formatLookupCode(lookupCode);
  const response = await Get({
    url: `${API_BASE_URL}/employee-lookups/get/${id}`,
  });
  return response;
};

// Create new lookup item
const CreateLookupItem = async (lookupCode, data) => {
  const response = await Post({
    url: `${API_BASE_URL}/employee-lookups/create`,
    data: data,
  });
  return response;
};

// Update existing lookup item
const UpdateLookupItem = async (lookupCode, id, data) => {
  // const formattedCode = formatLookupCode(lookupCode);
  const response = await Put({
    url: `${API_BASE_URL}/employee-lookups/update/${id}`,
    data: data,
  });
  return response;
};

// Delete lookup item
const DeleteLookupItem = async (lookupCode, id) => {
  const response = await Delete({
    url: `${API_BASE_URL}/employee-lookups/delete/${id}`,
  });
  return response;
};

// Save UserRole with combined role and permissions data
const SaveUserRole = async (roleData, roleId = null) => {
  const companyID = getCompanyID();

  // Determine if this is create or edit based on roleData.id
  const isEdit = roleData.id && roleData.id !== '';
  const actualRoleId = roleId || roleData.id || null;

  // Transform role data to API format
  const employeeLookup = {
    id: isEdit ? roleData.id : null,  // null for create, actual id for edit
    companyID: companyID,
    nameAr: roleData.nameAr || roleData.nameEn || '',
    nameEn: roleData.nameEn || '',
    code: roleData.code || '',
    isDefault: roleData.isDefault || false,
    parentID: roleData.parentID || null,
    codeRowType: 'UserRole',
    optional_1: roleData.optional_1 || '',
    optional_2: roleData.optional_2 || '',
    optional_3: roleData.optional_3 || '',
    optional_4: roleData.optional_4 || ''
  };

  // Transform permissions data to API format
  const rolePrivilegeMappingList = [];
  if (roleData.selectedPermissions && roleData.selectedPermissions.length > 0) {
    roleData.selectedPermissions.forEach(permission => {
      rolePrivilegeMappingList.push({
        id: permission.id || '',
        roleId: actualRoleId,  // null for create, actual roleId for edit
        companyID: companyID,
        menuDefinitionID: permission.menuDefinitionID || '',
        actionId: permission.actionId || '',
        isAllowed: permission.isAllowed || true
      });
    });
  }

  const payload = {
    rolePrivilegeMappingList: rolePrivilegeMappingList,
    employeeLookup: employeeLookup
  };

  console.log(' Saving UserRole with combined data:', payload);
  console.log(' Operation type:', isEdit ? 'EDIT' : 'CREATE', 'roleId:', actualRoleId);

  const response = await Post({
    url: `${API_BASE_URL}/role/save?companyID=${companyID}`,
    data: payload,
  });

  return response;
};

// Break Definition Functions
// const GetAllBreakDefinition = async () => {
//   const response = await Get({
//     url: `${API_BASE_URL}${GetAllBreakDefinition}`,
//   });
//   return response;
// };

// const SaveBreakDefinition = async (breakDefinition, id) => {
//   if (id === '') {
//     const response = await Post({
//       url: `${API_BASE_URL}${AddBreakDefinition}`,
//       data: breakDefinition,
//     });
//     return response;
//   } else {
//     const response = await Put({
//       url: `${API_BASE_URL}${UpdateBreakDefinition}/${id}`,
//       data: breakDefinition,
//     });
//     return response;
//   }
// };

// const DeleteBreakDefinition = async (id) => {
//   const response = await Delete({
//     url: `${API_BASE_URL}${DeleteBreakDefinition}/${id}`,
//   });
//   return response;
// };



const Lookup = {
  GetWorkLocation,
  GetUserType,
  SaveUserType,
  DeleteUserType,
  GetJobGrade,
  GetEmployeeType,
  SaveEmployeeType,
  DeleteEmployeeType,
  GetDesignation,
  GetNationality,
  GetReligion,
  SaveWorkLocations,
  DeleteWorkLocation,
  SaveReligion,
  DeleteReligion,
  SaveNationality,
  DeleteNationality,
  DeleteDesignation,
  SaveDesignation,
  SaveJobGrade,
  DeleteJobGrade,
  SaveEmployeeException,
  DeleteEmployeeException,
  GetEmployeeException,
  GetReader,
  SaveReader,
  DeleteReader,
  GetCompany,
  SaveCompany,
  DeleteCompany,
  GetCompanySize,
  GetCompanyType,
  GetNoLocations,
  GetEntity,
  GetEntityPaginated,
  GetEntityByParentId,
  GetEmployeeByEntityId,
  getEmployeeByNumber,
  SaveEntity,
  DeleteEntity,
  GetEntityLevel,
  SaveEntityLevel,
  DeleteEntityLevel,
  GetEmployee,
  GetEmployeePagination,
  SaveEmployee,
  DeleteEmployee,
  GetEmployeeStatus,
  SaveEmployeeStatus,
  DeleteEmployeeStatus,
  GetAllActiveEmployee,
  GetFormControl,
  SaveForm,
  GetForms,
  DeleteLeaveDefinition,
  GetLeaveDefinition,
  SaveLeaveDefinition,
  DeleteEmployeeGroup,
  GetEmployeeGroup,
  SaveEmployeeGroup,
  GetWorkFlowStages,
  GetWorkFlowAssignTypes,
  SaveWorkFlow,
  GetWorkFlow,
  DeleteWorkFLow,
  GetAllTargetEmployees,
  GetAllPolicy,
  DeletePolicy,
  SavePolicy,
  ChangePolicyPriority,
  GetFormByWorkFlow,
  GetFullWorkFlowDetails,
  GetNotificationTypes,
  SaveNotification,
  DeleteNotification,
  GetNotification,
  GetNotificationByID,
  GetNotificationByKind,
  DeleteForm,
  GetAllManagers,
  GetAllSubordinates,
  GetLeaveType,
  SaveLeaveType,
  DeleteLeaveType,
  GetEmployeeCategory,
  GetAllEmployeeLeaves,
  SaveEmployeeLookups,
  DeleteEmployeeLookups,
  GetEmployeeLookups,
  GetEmployeeByIDApi,
  SaveDesignationCategory,
  GetDesignationCategory,
  DeleteDesignationCategory,
  SaveRemoteWorkDefinition,
  GetRemoteWorkDefinition,
  DeleteRemoteWorkDefinition,
  GetEmployeeEntityPrivilege,
  SaveEmployeeEntityPrivilege,
  DeleteEmployeeEntityPrivilege,
  GetEmployeeContract,
  SaveEmployeeContract,
  DeleteEmployeeContract,
  GetLookupMetadata,
  GetLookupData,
  GetLookupItemById,
  CreateLookupItem,
  UpdateLookupItem,
  DeleteLookupItem,
  GetUserRoleMenuActions,
  TransformUserRoleMenuActions,
  SaveUserRole,
  GetUserRoleById,
  GetEmployeeLookupById,
  GetMetaData
};

export default Lookup;
